import React, { useEffect, useMemo, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import SEO from '../../components/SEO';
import AnimusHeroChrome from '../../components/AnimusHeroChrome';
import { apiGet } from '../../api/client';
import { StreamSectionRenderer } from './StreamSectionRenderer';
import '../../styles.css';

export function streamPagePath(slug) {
  return `/stream-${slug}`;
}

export default function StreamPage({ slug: slugProp }) {
  const { slug: slugParam } = useParams();
  const slug = slugProp || slugParam;
  const [page, setPage] = useState(null);
  const [schedule, setSchedule] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const needsSchedule = useMemo(
    () => page?.content?.sections?.some((s) => s.type === 'scheduleCalendar'),
    [page],
  );

  useEffect(() => {
    setLoading(true);
    setError(null);
    apiGet(`/stream-pages/${slug}`)
      .then(setPage)
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, [slug]);

  useEffect(() => {
    if (!needsSchedule) {
      setSchedule([]);
      return;
    }
    apiGet('/schedule')
      .then(setSchedule)
      .catch(console.error);
  }, [needsSchedule]);

  if (loading) {
    return (
      <>
        <Navbar />
        <main className="container" style={{ padding: '4rem 0' }}>
          <div className="video-loading"><div className="spinner"></div></div>
        </main>
        <Footer />
      </>
    );
  }

  if (error || !page) {
    return (
      <>
        <Navbar />
        <main className="container" style={{ padding: '4rem 0' }}>
          <h1>Page not found</h1>
          <p>{error || 'This stream page does not exist.'}</p>
          <Link to="/stream" className="btn btn-primary">Back to Stream</Link>
        </main>
        <Footer />
      </>
    );
  }

  const seo = page.seo || {};
  const hero = page.hero || {};
  const sections = page.content?.sections || [];

  return (
    <>
      <SEO
        title={page.title}
        description={seo.description}
        keywords={seo.keywords}
        url={seo.url}
      />
      <Navbar />
      <main>
        <section className="stream-hero animus-hero animus-hero-bg">
          <AnimusHeroChrome />
          <div className="container">
            <p className="animus-hero-id font-mono">{'// SECTION_STREAM'}</p>
            <h1>
              {hero.title}
              {hero.highlight && <span className="highlight"> {hero.highlight}</span>}
            </h1>
            {hero.subtitle && <p>{hero.subtitle}</p>}
          </div>
        </section>

        <section className="stream-section page-body-section">
          <div className="container">
            <div className="stream-container">
              {sections.map((section, i) => (
                <StreamSectionRenderer
                  key={`${section.type}-${i}`}
                  section={section}
                  schedule={schedule}
                />
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
